
import { authHeaderwithJson } from '../helpers';
import apiUrl, { apiConstants } from '../constants';

export const userService = {
    login,
    logout,
    hasRoles,
    getLoginTime,
    getUserCity,
    changepass

};

function login(username, password) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
    };

    return fetch(`${apiConstants.API_URL}/Auth/login`, requestOptions)
        .then(handleResponse)
        .then(user => {
            // login successful if there's a jwt token in the response
            if (user.auth_token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(user));
            }

            return user;
        });
}


function changepass(model) {
    const requestOptions = {
        method: 'POST',
        headers: authHeaderwithJson(),
        body: JSON.stringify(model)
    };

    return fetch(`${apiConstants.API_URL}/Auth/ChangePassword`, requestOptions)
        .then(handleResponse)
        
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
}
function getLoginTime() {
    let token = JSON.parse( localStorage.getItem('user') );
    if(token == null || token ==undefined) return null;
    return token.user.loginTime;
}
function getUserCity() {
    let token = JSON.parse( localStorage.getItem('user') );
    if(token == null || token ==undefined) return null;
    if(token.user.city == null ) return null;
    return token.user.city;
}

function hasRoles(roles) {
   
    if(roles==undefined) return true;

    let token = JSON.parse( localStorage.getItem('user') );
    if(token == null || token ==undefined) return false;
    
    let user=token.user;

   
    let userroles=user.roles;
    
    if(userroles!=null || userroles!=undefined)
    {
        var hasRole=false;
        userroles.forEach(function(role) {
            console.log(role);
           hasRole = (roles.indexOf(role) >= 0);
           
        });  
        return hasRole;     
    } 

    console.log(roles);

    return false;
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
               // location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}